import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_toggle_group_4f42c91c__ from "@radix-ui/react-toggle-group";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__ from "../lib/utils.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__toggle_mjs_5e0ddd0e__ from "./toggle.mjs";
const ToggleGroupContext = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.createContext({
    size: "default",
    variant: "default"
});
const ToggleGroup = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ className, variant, size, children, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_toggle_group_4f42c91c__.Root, {
        ref: ref,
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("tw-flex tw-items-center tw-justify-center tw-gap-1", className),
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ToggleGroupContext.Provider, {
            value: {
                variant,
                size
            },
            children: children
        })
    }));
ToggleGroup.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_toggle_group_4f42c91c__.Root.displayName;
const ToggleGroupItem = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ className, children, variant, size, ...props }, ref)=>{
    const context = __WEBPACK_EXTERNAL_MODULE_react__.useContext(ToggleGroupContext);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_toggle_group_4f42c91c__.Item, {
        ref: ref,
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)((0, __WEBPACK_EXTERNAL_MODULE__toggle_mjs_5e0ddd0e__.toggleVariants)({
            variant: context.variant || variant,
            size: context.size || size
        }), className),
        ...props,
        children: children
    });
});
ToggleGroupItem.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_toggle_group_4f42c91c__.Item.displayName;
export { ToggleGroup, ToggleGroupItem };

//# sourceMappingURL=toggle-group.mjs.map